'use client'

import { useRouter } from 'next/navigation'
import { useEffect } from 'react'
import { Spinner } from '@/components/ui/spinner'

export function ProcessingState({ redirectTo }: { redirectTo: string }) {
  const router = useRouter()

  useEffect(() => {
    router.replace(redirectTo)
  }, [redirectTo, router])

  return (
    <div className='flex h-screen w-full flex-col items-center justify-center gap-4 bg-black text-white'>
      <Spinner className='size-8 text-white' />
      <p className='font-medium text-sm uppercase tracking-widest opacity-70'>Finalizing…</p>
    </div>
  )
}
